import { Component, OnInit } from '@angular/core';
import { AuthService } from '../core/auth.service';
import { ApiService } from '../core/api.service';
import { ToastService } from '../core/toast.service';
import { TITLES, graduationYears, passwordStrength } from '../core/app-date.pipe';
import { Router } from '@angular/router';

@Component({
  selector: 'app-dashboard',
  template: `
  <h1 class="page-title">Welcome, {{ auth.user?.firstName }}</h1>
  <p class="muted">What would you like to do today?</p>

  <div class="card" *ngIf="services.length">
    <div class="card-head">Your résumés at a glance</div>
    <div class="stat-row">
      <a class="stat" *ngFor="let s of services" [routerLink]="['/my-resumes', s.slug]">
        <b>{{ s.myCount }}</b><span>{{ s.title }}</span>
      </a>
    </div>
  </div>

  <!-- Resource Center Central — links will be added later; blocks are display-only for now -->
  <div class="rc-band">Resource Center Central <span class="now-open">NOW OPEN</span></div>
  <div class="rc-grid">
    <div class="rc-card" *ngFor="let c of resourceCenters" [title]="c.title">
      <div class="rc-title">{{ c.title }}</div>
      <div class="rc-art"><img [src]="'assets/resource-centers/' + c.key + '.png'" [alt]="c.title"></div>
      <div class="rc-tag" *ngIf="c.tagline">{{ c.tagline }}</div>
    </div>
  </div>`
})
export class DashboardComponent implements OnInit {
  services: any[] = [];
  resourceCenters = [
    { key: 'academics', title: 'Academics Resource Center' },
    { key: 'admissions', title: 'Admissions Resource Center' },
    { key: 'eligibility', title: 'Eligibility Resource Center' },
    { key: 'accelerated-learning', title: 'Accelerated Learning Resource Center', tagline: 'Study With The Bright Minds!' },
    { key: 'counseling-services', title: 'Counseling Services Resource Center' },
    { key: 'financial-aid', title: 'Financial Aid Resource Center' },
    { key: 'medical', title: 'Medical Resource Center' },
    { key: 'recruiting', title: 'Recruiting Resource Center', tagline: 'Prospective Student Athletes (PSAs)' },
    { key: 'standardized-testing', title: 'Standardized Testing Resource Center' }
  ];
  constructor(public auth: AuthService, private api: ApiService) {}
  ngOnInit() {
    if (this.auth.can('MY_RESUMES')) { this.api.get<any[]>('/resumes/services').subscribe(s => this.services = s); }
  }
}

@Component({
  selector: 'app-my-account',
  template: `
  <h1 class="page-title">My Account</h1>
  <p class="muted">Your profile, résumés and sign-in security in one place.</p>
  <div class="tiles">
    <a class="tile" routerLink="/profile" *ngIf="auth.can('MY_PROFILE')">
      <div class="disc blue">👤</div><div class="tile-label">My Profile</div>
    </a>
    <a class="tile" routerLink="/my-resumes" *ngIf="auth.can('MY_RESUMES')">
      <div class="disc orange">📄</div><div class="tile-label">My Resumes</div>
    </a>
    <a class="tile" routerLink="/security" *ngIf="auth.can('CHANGE_PASSWORD')">
      <div class="disc teal">🔒</div><div class="tile-label">Security and Passwords</div>
    </a>
    <a class="tile" (click)="auth.askLogout()">
      <div class="disc dark">⎋</div><div class="tile-label">Logout</div>
    </a>
  </div>

`
})
export class MyAccountComponent {
  constructor(public auth: AuthService) {}
}

@Component({
  selector: 'app-profile',
  template: `
  <div class="panel">
    <div class="panel-head">Profile</div>
    <form class="panel-body form-rows" *ngIf="p" (ngSubmit)="save()" #f="ngForm">
      <div class="row"><label>Username</label><input name="username" [value]="p.username" disabled title="Ask an administrator to change your username"></div>
      <div class="row"><label class="req">Email</label><input name="email" type="email" [(ngModel)]="p.email" required email></div>
      <div class="row"><label class="req">First Name</label><input name="fn" [(ngModel)]="p.firstName" required></div>
      <div class="row"><label>Middle Name</label><input name="mn" [(ngModel)]="p.middleName" placeholder="Middle Name"></div>
      <div class="row"><label class="req">Last Name</label><input name="ln" [(ngModel)]="p.lastName" required></div>
      <div class="row"><label>Title</label>
        <select name="title" [(ngModel)]="p.title"><option [ngValue]="null">—</option><option *ngFor="let t of titles" [value]="t">{{ t }}</option></select>
      </div>
      <div class="row"><label>Cell Phone</label><input name="phone" [(ngModel)]="p.cellPhone"></div>
      <div class="row"><label>Address</label><textarea name="addr" rows="2" [(ngModel)]="p.address"></textarea></div>
      <div class="row"><label>City</label><input name="city" [(ngModel)]="p.city"></div>
      <div class="row"><label>State</label><input name="state" [(ngModel)]="p.state"></div>
      <div class="row"><label>Zip Code</label><input name="zip" [(ngModel)]="p.zipCode"></div>

      <div class="band">Optional (For Students / Student Athletes only)</div>
      <div class="row"><label>What is your Graduation Class?</label>
        <select name="grad" [(ngModel)]="p.graduationClass"><option [ngValue]="null">Not applicable</option><option *ngFor="let y of years" [value]="y">{{ y }}</option></select>
      </div>

      <div class="row readonly">
        <label>Account</label>
        <div class="muted small">{{ p.orgName }} · {{ p.branchName || 'No branch' }} · {{ p.roleName || 'Member' }}</div>
      </div>
      <div class="row"><label></label><button class="btn primary" [disabled]="busy || !f.valid">UPDATE MY PROFILE</button></div>
    </form>
  </div>`
})
export class ProfileComponent implements OnInit {
  p: any;
  busy = false;
  titles = TITLES;
  years = graduationYears();
  constructor(private api: ApiService, private toast: ToastService, private auth: AuthService) {}
  ngOnInit() { this.api.get('/profile').subscribe(p => this.p = p); }
  save() {
    this.busy = true;
    this.api.put('/profile', this.p).subscribe(
      r => { this.busy = false; this.toast.ok(r.message); this.auth.refresh().subscribe(); },
      e => { this.busy = false; this.toast.err(ApiService.message(e)); }
    );
  }
}

@Component({
  selector: 'app-change-password',
  template: `
  <div class="panel narrow">
    <div class="panel-head">Change Password</div>
    <div class="alert info" *ngIf="auth.session?.mustChangePassword">Please set your own password before continuing.</div>
    <form class="panel-body form-rows" (ngSubmit)="save()" #f="ngForm">
      <div class="row"><label>Old Password :</label>
        <div class="pwd"><input name="o" [type]="show ? 'text' : 'password'" [(ngModel)]="m.oldPassword" required autocomplete="current-password">
        <button type="button" class="eye" (click)="show = !show">{{ show ? 'Hide' : 'Show' }}</button></div>
      </div>
      <div class="row"><label>New Password :</label>
        <div>
          <input name="n" [type]="show ? 'text' : 'password'" [(ngModel)]="m.newPassword" required autocomplete="new-password">
          <div class="meter" *ngIf="m.newPassword"><span [ngClass]="strength().toLowerCase()">{{ strength() }}</span></div>
        </div>
      </div>
      <div class="row"><label>Confirm New Password :</label>
        <div>
          <input name="c" [type]="show ? 'text' : 'password'" [(ngModel)]="m.confirmPassword" required autocomplete="new-password">
          <div class="field-err" *ngIf="m.confirmPassword && m.confirmPassword !== m.newPassword">Passwords do not match.</div>
        </div>
      </div>
      <div class="row"><label></label>
        <button class="btn primary" [disabled]="busy || !f.valid || m.newPassword !== m.confirmPassword || strength() === 'Poor'">UPDATE PASSWORD</button>
      </div>
    </form>
  </div>`
})
export class ChangePasswordComponent {
  m: any = {};
  show = false;
  busy = false;
  constructor(private api: ApiService, private toast: ToastService, public auth: AuthService, private router: Router) {}
  strength() { return passwordStrength(this.m.newPassword); }
  save() {
    this.busy = true;
    this.api.post('/profile/change-password', this.m).subscribe(
      r => {
        this.busy = false; this.toast.ok(r.message); this.m = {};
        if (this.auth.session.mustChangePassword) { this.auth.patch({ mustChangePassword: false }); this.router.navigate(['/dashboard']); }
      },
      e => { this.busy = false; this.toast.err(ApiService.message(e)); }
    );
  }
}
